import { createSlice } from "@reduxjs/toolkit";
import { fetchProductData, fetchProductDetails, getApiObject, } from "../utils/apiUtils";
import isEmpty from "lodash/isEmpty";
import clone from "lodash/clone";
export const defaultState = {
    products: getApiObject([]),
    productByIds: getApiObject({}),
};
export const productsReducer = createSlice({
    name: "productlist",
    initialState: defaultState,
    reducers: {
        setProductList: (state, action) => {
            state.products = action.payload;
        },
        setProductsByIds: (state, action) => {
            state.productByIds = action.payload;
        },
    },
});
export const { setProductList, setProductsByIds } = productsReducer.actions;
export const fetchProducts = () => async (dispatch) => {
    try {
        dispatch(setProductList(getApiObject([], true)));
        const productResponse = await fetchProductData();
        dispatch(setProductList(getApiObject(productResponse)));
    }
    catch (error) {
        dispatch(setProductList(getApiObject([], false, false, true, error?.message, error)));
    }
};
export const fetchProductById = (id) => async (dispatch, getState) => {
    const existingProductsIds = getState()?.products?.productByIds?.data || {};
    if (!isEmpty(existingProductsIds?.[id])) {
        return;
    }
    dispatch(setProductsByIds(getApiObject(existingProductsIds, true)));
    try {
        const latestProductById = await fetchProductDetails(id);
        const existingValues = clone(existingProductsIds);
        if (!isEmpty(latestProductById)) {
            existingValues[id] = latestProductById;
        }
        dispatch(setProductsByIds(getApiObject(existingValues)));
    }
    catch (error) {
        dispatch(setProductsByIds(getApiObject(existingProductsIds, false, false, true, error?.message, error)));
    }
};
export default productsReducer.reducer;
